import React from 'react';

export default class PhotoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.galleryRef = React.createRef();
  }

  componentDidMount() {
    this.galleryRef.current.images = this.props.images;
  }

  render() {
    return (
      <sh-photo-gallery ref={this.galleryRef}></sh-photo-gallery>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/photo-gallery.js